<template>
  <v-card flat>
    <v-flex xs12 class="px-3">
      <v-data-table hide-actions :items="items" :headers="headers">
        <template slot="items" slot-scope="{ item }">
          <td>
            <v-checkbox
              readonly
              hide-details
              color="primary"
              :label="item.title"
              :input-value="hasAccess('all_' + item.name)"
            />
          </td>
          <td>
            <v-checkbox
              readonly
              hide-details
              color="primary"
              :input-value="hasAccess('view_' + item.name)"
            />
          </td>
          <td>
            <v-checkbox
              readonly
              hide-details
              color="primary"
              :input-value="hasAccess('add_' + item.name)"
            />
          </td>
          <td>
            <v-checkbox
              readonly
              hide-details
              color="primary"
              :input-value="hasAccess('edit_' + item.name)"
            />
          </td>
          <td>
            <v-checkbox
              readonly
              hide-details
              color="primary"
              :input-value="hasAccess('delete_' + item.name)"
            />
          </td>
        </template>
        <template slot="footer">
          <td colspan="5">
            <div class="extra_permissions py-3">
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('view_accounts')"
                :input-value="hasAccess('view_accounts')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('general_ledger')"
                :input-value="hasAccess('ledger_report')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('lctr_report')"
                :input-value="hasAccess('lctr_report')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('daily_profits')"
                :input-value="hasAccess('daily_profit')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('incomes')"
                :input-value="hasAccess('view_profits')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('cash_accounts')"
                :input-value="hasAccess('view_cash_accounts')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('change_rate')"
                :input-value="hasAccess('change_rate')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('view_all_branches_report')"
                :input-value="hasAccess('view_all_branches_report')"
              />
              <v-checkbox
                readonly
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('transactions_report')"
                :input-value="hasAccess('transactions_report')"
              />
              <v-checkbox
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('view_dashboard')"
                :input-value="hasAccess('view_dashboard')"
              />
              <v-checkbox
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('view_chart')"
                :input-value="hasAccess('view_chart')"
              />
              <v-checkbox
                hide-details
                color="primary"
                class="grid-item"
                :label="$t('delete_files')"
                :input-value="hasAccess('delete_files')"
              />
            </div>
          </td>
        </template>
      </v-data-table>
    </v-flex>

    <v-card-actions
      class="grey lighten-4 py-0 mt-2"
      style="flex-direction: row-reverse"
      v-if="
        userCan('delete_roles') || (userCan('edit_roles') && name != 'Manager')
      "
    >
      <v-btn
        flat
        icon
        class="mx-0"
        color="grey darken-1"
        @click="$emit('delete')"
        v-if="userCan('delete_roles')"
      >
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        class="mx-0"
        color="grey darken-1"
        @click="$emit('edit')"
        v-if="userCan('add_roles')"
      >
        <v-icon>edit</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ["permissions", "name"],
  data() {
    return {
      headers: [
        {
          value: "title",
          sortable: false,
          text: this.$t("part"),
        },
        { text: this.$t("view"), value: "s", sortable: false },
        { text: this.$t("add"), value: "c", sortable: false },
        { text: this.$t("edit"), value: "e", sortable: false },
        { text: this.$t("delete"), value: "d", sortable: false },
      ],
    };
  },
  computed: {
    items() {
      if (!this.permissions) {
        return [];
      } else {
        return [
          {
            title: this.$t("individuals"),
            name: "individuals",
          },
          {
            title: this.$t("corporates"),
            name: "corporates",
          },
          {
            title: this.$t("customers"),
            name: "customers",
          },
          {
            title: this.$t("branchs"),
            name: "branchs",
          },
          {
            title: this.$t("staffs"),
            name: "staffs",
          },
          {
            title: this.$t("sarafs"),
            name: "sarafs",
          },
          {
            title: this.$t("sarafs_commission"),
            name: "commissions",
          },
          {
            title: this.$t("shareholders"),
            name: "shareholders",
          },
          {
            title: this.$t("externals"),
            name: "externals",
          },
          {
            title: this.$t("banks"),
            name: "banks",
          },
          {
            title: this.$t("expenses"),
            name: "expenses",
          },
          {
            title: this.$t("incomes"),
            name: "incomes",
          },
          {
            title: this.$t("fixed_assets"),
            name: "assets",
          },
          {
            title: this.$t("liabilities"),
            name: "liabilities",
          },
          {
            title: this.$t("credits"),
            name: "credits",
          },
          {
            title: this.$t("debits"),
            name: "debits",
          },
          {
            title: this.$t("exchanges"),
            name: "exchanges",
          },
          {
            title: this.$t("send_transfers"),
            name: "send_transfers",
          },
          {
            title: this.$t("receive_transfers"),
            name: "receive_transfers",
          },
          {
            title: this.$t("a2a_transfers"),
            name: "a2a_transfers",
          },
          {
            title: this.$t("roles"),
            name: "roles",
          },
          {
            title: this.$t("users"),
            name: "users",
          },
          {
            title: this.$t("currencies"),
            name: "currencies",
          },
          {
            title: this.$t("backups"),
            name: "backups",
          },
        ];
      }
    },
  },
  methods: {
    hasAccess(permission) {
      let array = Object.values(this.permissions);
      return array.some((p) => p.name == permission);
    },
  },
};
</script>